import { render, staticRenderFns } from "./TemporaryStorage.vue?vue&type=template&id=04f31b14&scoped=true"
import script from "./TemporaryStorage.vue?vue&type=script&lang=js"
export * from "./TemporaryStorage.vue?vue&type=script&lang=js"
import style0 from "./TemporaryStorage.vue?vue&type=style&index=0&id=04f31b14&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f31b14",
  null
  
)

export default component.exports